import { TableHead } from '@/components/Datatable/TableHead';
import { SortableTableHeadersProps } from '@/type/listing.types';
import { SETTINGS_TIPS } from '@/docs/tips/settings';

export const CheckPointTableHeaders = ({
  t,
  onSort,
}: SortableTableHeadersProps) => {
  return (
    <>
      <TableHead
        text={t('common:checkPoint')}
        // thClassName="w-[310px]"
        thClassName="w-[270px] max-sm:min-w-[170px]"
        sortable
        onSortClick={() => onSort?.('checkPointName')}
      />
      {/* <TableHead text={t('common:type')} thClassName="min-w-[200px]" /> */}
      <TableHead
        text={t('common:type')}
        thClassName="min-w-0 w-0"
        infoTip={SETTINGS_TIPS.checkPointTypeColumn}
      />
      <TableHead
        text={t('common:icons')}
        thClassName="max-sm:min-w-[230px]"
        infoTip={SETTINGS_TIPS.checkPointIconsColumn}
      />
      <TableHead thClassName="sticky-action-column" />
    </>
  );
};
